import { CreateCustomerDto } from "../customers/CreateCustomerDto";

export class CreateTicketDto {
    comments: string = '';
    ticketTypeId: number = 0;
    customer: CreateCustomerDto = new CreateCustomerDto();
    quantity: number = 1;
}